import { gql } from "@apollo/client";
import {ImageFragment, ResponseFragment, RoomFragment} from "./fragments";

export const GET_PHASES = gql`
    query GetPhases {
        phases {
            documentId
            name
            messages(pagination: { limit: 100 }) {
                documentId
                name
                transaktions_name
                sender
                text
                type
                meme_icon {
                    documentId
                    name
                    icon {
                        ...ImageFragment
                    }
                }
                image {
                    ...ImageFragment
                }
                vertical_button_order
                Response {
                    ...ResponseFragment
                    followUpMessage {
                        documentId
                        name
                        transaktions_name
                        sender
                        text
                        type
                        meme_icon {
                            documentId
                            name
                            icon {
                                ...ImageFragment
                            }
                        }
                        image {
                            ...ImageFragment
                        }
                        vertical_button_order
                        Response {
                            ...ResponseFragment
                        }
                    }
                }
                educational_message {
                    documentId
                    headline
                    text
                    image {
                        ...ImageFragment
                    }
                }
                disable_timer
            }
            room_a {
                ...RoomFragment
            }
            room_b {
                ...RoomFragment
            }
        }
    }
    ${ResponseFragment}
    ${ImageFragment}
    ${RoomFragment}
`;

export const GET_ACHIEVEMENTS = gql`
    query GetAchievements {
        achievements(pagination: { limit: 100 }) {
            documentId
            name
            image {
                ...ImageFragment

            }
        }
    }
    ${ImageFragment}
`;

export const GET_GAME_CONFIGURATION = gql`
    query GetGameConfiguration {
        gameConfiguration {
            documentId
            gameOverBrokeFallbackFinanceType{
                documentId
                name
                subline
                
            }
            gameOverSadFallbackFinanceType{
                documentId
                name
                subline
            }
            DebugMode
            PhaseOrder {
                documentId
            }
            AchievementOrder(pagination: { limit: 100 }) {
                documentId
            }
            shareText
            shareImageFilename
            SplashImage {
                ...ImageFragment
            }
            shareImageFilename
        }
    }
    ${ImageFragment}
`;

export const GET_FINANCE_TYPES = gql`
    query GetFinanceTypes {
        financeTypes(pagination: { limit: 100 }) {
            documentId
            name
            subline
        }
    }
`;

export const GET_META_TAGS = gql`
    query GetMetaTags {
        metaTag {
            documentId
            titleTag
            metaDescription
            sharePreviewImage {
                ...ImageFragment
            }
        }
    }
    ${ImageFragment}
`;

export const GET_LEGAL = gql`
    query GetLegal {
        legal {
            documentId
            Datenschutz
            Impressum
        }
    }
`;

export const GET_GAME_END = gql`
    query GetGameEnd {
        gameEnd {
            documentId
            gameOverCashHeadline
            gameOverCashText
            gameOverSadHeadline
            gameOverSadText
            gameOverRentHeadline
            gameOverRentText
            polaroidItemA {
                ...ImageFragment
            }
            polaroidItemB {
                ...ImageFragment
            }
        }
    }
    ${ImageFragment}
`;